"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_memoize_1 = __importDefault(require("lodash.memoize"));
var lodash_values_1 = __importDefault(require("lodash.values"));
function default_1(fn) {
    return lodash_memoize_1.default(fn, function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return lodash_values_1.default(args).join('_');
    });
}
exports.default = default_1;
//# sourceMappingURL=fastMemoize.js.map